import {view} from '@sail/ui';
import {ConversationLogItemCustomComponent} from '@stripe-internal/conversations-client';
import {CallToActionComponent} from './CallToActionComponent';

type Props = {
  componentType: ConversationLogItemCustomComponent['componentType'];
  data: ConversationLogItemCustomComponent['data'];
};

export const CustomComponent = ({componentType, data}: Props) => {
  if (componentType !== 'call-to-action') {
    return null;
  }

  return (
    <view.div data-testid="custom-component-message">
      <CallToActionComponent {...data} />
    </view.div>
  );
};
